/* RevitalGlow - accordions that open and close with motion, one at a time.

   Opt in by putting data-rg-accordion on the wrapper around a set of <details>
   elements. Every <details> inside it then behaves like the product page's
   Product description / FAQ / Shipping dropdowns: the panel slides open, and
   opening one slides the previous one shut instead of snapping it closed.

   Kept as plain <details> markup on purpose - it still works, and is still
   readable by search engines and screen readers, if this script never loads.

   Used by: sections/rg-lp-faq.liquid, sections/rg-hp-faq.liquid. */
(function () {
  if (window.__rgAccordion) return;
  window.__rgAccordion = true;

  var DURATION = 280;
  var EASING = 'cubic-bezier(.33, 0, .2, 1)';

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function panelOf(details) {
    var summary = details.querySelector('summary');
    return summary ? summary.nextElementSibling : null;
  }

  /* Height AND vertical padding have to travel together, otherwise the panel
     keeps its padding at height 0 and the row jumps at the end. */
  function frames(panel, opening) {
    var cs = window.getComputedStyle(panel);
    var open = { height: panel.scrollHeight + 'px', paddingTop: cs.paddingTop, paddingBottom: cs.paddingBottom, opacity: 1 };
    var shut = { height: '0px', paddingTop: '0px', paddingBottom: '0px', opacity: 0 };
    return opening ? [shut, open] : [open, shut];
  }

  function run(details, opening, onDone) {
    var panel = panelOf(details);
    if (!panel || !panel.animate || prefersReducedMotion()) {
      details.open = opening;
      if (onDone) onDone();
      return;
    }
    if (details.__rgAnim) details.__rgAnim.cancel();
    if (opening) details.open = true;

    panel.style.overflow = 'hidden';
    var animation = panel.animate(frames(panel, opening), { duration: DURATION, easing: EASING });
    details.__rgAnim = animation;

    animation.onfinish = function () {
      panel.style.overflow = '';
      details.__rgAnim = null;
      if (!opening) details.open = false;
      if (onDone) onDone();
    };
    animation.oncancel = function () {
      panel.style.overflow = '';
      details.__rgAnim = null;
    };
  }

  /* Capture phase on purpose: on the home page another script stops the click
     before it bubbles up to document, which left the accordion doing nothing
     and the browser toggling <details> instantly instead. */
  document.addEventListener('click', function (event) {
    var summary = event.target.closest && event.target.closest('[data-rg-accordion] summary');
    if (!summary) return;

    var details = summary.parentElement;
    if (!details || details.tagName !== 'DETAILS') return;

    /* The browser would toggle instantly; we animate instead. */
    event.preventDefault();

    if (details.open) {
      run(details, false);
      return;
    }

    var group = details.closest('[data-rg-accordion]');
    if (group) {
      group.querySelectorAll('details[open]').forEach(function (other) {
        if (other !== details) run(other, false);
      });
    }
    run(details, true);
  }, true);
})();